<template>
  <div v-loading.fullscreen.lock="uploadLoading">
    <template v-if="type != 2">
      <div class="operate">
        <el-upload
          class="upload-demo tow"
          :data="formData"
          :action="uploadForm.action"
          :before-upload="beforeAvatarUpload"
          :on-success="uploadSuccess"
          :show-file-list="false"
          :on-error="uploadError"
          :on-progress="onProgress"
          :headers="uploadForm.headers"
          multiple
        >
          <el-button plain type="single-number">上传附件</el-button>
        </el-upload>
      </div>
      <div class="clearfix"></div>
    </template>
    <el-table :data="fileData" border class="dic-sub-table-style01">
      <el-table-column
        type="index"
        :label="$t('page.content.serialNo')"
        width="50"
      />
      <el-table-column
        prop="fileName"
        :label="$t('page.content.fileName')"
        show-overflow-tooltip
        min-width="280"
      ></el-table-column>
      <el-table-column
        type="action"
        :label="$t('page.content.operation')"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="height: 36px; padding: 0;"
            @click="download(scope.$index, scope.row)"
            >{{ $t("page.content.upload") }}</el-button
          >
          <!--<template v-if="type == 2">-->
          <!--<el-button type="text" @click="preview(scope.row)">{{-->
          <!--$t("page.content.preview")-->
          <!--}}</el-button>-->
          <!--</template>-->
          <!--          <el-button type="text" @click="downloadUrlFile(scope.row)"-->
          <!--            >下载</el-button-->
          <!--          >-->
          <template v-if="type != 2">
            <el-button
              type="text"
              style="height: 36px; padding: 0;"
              @click="deleteRow(scope.$index, scope.row)"
              >{{ $t("page.content.delete") }}</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--- 上传附件填写基本信息 -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { pageTableWidth } from "@/setting/setting";
import { addUrlPerFix, getPreviewUrl } from "@/basa/utils";
import moment from "moment";

export default {
  name: "attachmentUpload",
  props: {
    fileData: {
      type: Array,
      default() {
        return [];
      }
    },
    // id: {
    //   type: String, // 修改、复制、查看详情
    //   default: ""
    // },
    type: {
      type: Number, // 0：修改、新增 1:复制 2： 查看详情
      default: 0
    },
    isShowDesc: {
      //是否展示附件说明，默认展示
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moment: moment,
      dateTimeWidth: pageTableWidth.dateTimeWidth,
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL + "/apis/pma/oss/uploadFileToOssAndSave"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      formData: {
        agentId: this.$router.history.current.query.a,
        
      },
      // fileData: [],
      uploadLoading: false,
      deletePlanAttachementList: [] // 删除的数据
    };
  },
  methods: {
    uploadSuccess(res, file, fileList) {
      this.$message.success("附件上传成功");
      this.uploadLoading = false;
      let fileData = res.data[0];
      this.fileData.push({
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: "",
        createTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId
      });
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "上传出错，请联系管理员",
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading = false;
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = true;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "ppt" ||
        testmsg === "pptx" ||
        testmsg === "pdf" ||
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "txt" ||
        testmsg === "rft" ||
        testmsg === "msg" ||
        testmsg === "wps" ||
        testmsg === "et" ||
        testmsg === "dps" ||
        testmsg === "vsd" ||
        testmsg === "prn" ||
        testmsg === "ai" ||
        testmsg === "cad" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "PDF" ||
        testmsg === "tiff" ||
        testmsg === "TIFF" ||
        testmsg === "swf" ||
        testmsg === "SWF" ||
        testmsg === "bmp" ||
        testmsg === "gif" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "rar" ||
        testmsg === "RAR" ||
        testmsg === "zip" ||
        testmsg === "7z" ||
        testmsg === "lzh" ||
        testmsg === "LZH";
      if (!isLt50) {
        this.uploadLoading = false;
        this.$message({
          message: "文件大小不可超过50M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      if (!extension) {
        this.uploadLoading = false;
        this.$message({
          message: "上传文件格式错误！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && extension;
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/hwsp/oss/users/signup/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    deleteRow(index, row) {
      if (row.fileinfoId) {
        this.deletePlanAttachementList.push(row.fileinfoId);
      }
      this.fileData.splice(index, 1);
    },
    //预览
    preview({ uploadId }) {
      getPreviewUrl(uploadId);
      // const previewSrc = getPreviewUrl(fileUrl);
      // window.open(previewSrc);
    }
  },
  mounted() {
    console.log(this.fileData);
  }
};
</script>

<style lang="scss" scoped>
.operate {
  float: right;
}
.upload-demo {
  margin-bottom: 20px;
}
/deep/ {
  .el-input input {
    padding-right: 60px;
  }
}
</style>
